@if (showModalCP) {
<app-alert-modal [isSuccess]="isSuccess" [showIcon]="!isConfirm" [hasButtons]="isConfirm" [txtConfirmButton]="'Aceptar'"
    [message]="messagesError" [isHtml]="true" (onCancel)="showModalCP=false;"
    (onConfirm)="showModalCP=false;updateZipCode()"></app-alert-modal>
}

<div class="w-full mt-5 max-h-[300px] overflow-y-auto dark:shadow-none shadow-sm">
    @if(!isInvoiced){
    
    <div class="flex flex-col md:flex-row p-2 space-x-5">
        <div class="text-left w-1/2">
            <h1 class="text-lg font-semibold text-vivid-royal-800">
                {{invoiceCompany.name}}

            </h1>
            <div class="text-zinc-500 text-sm">
                <p>
                    {{invoiceCompany.address}}
                </p>
                <div class="flex items-center">
                    <span>{{invoiceCompany.city}} {{invoiceCompany.state}} C.P. {{invoiceCompany.zipCode}}</span> 
                </div>
                <p>
                </p>
                <p>
                    {{invoiceCompany.phone}}
                </p>
            </div>
            <div class=" flex w-full bg-vivid-royal-500 text-dark-khaki-50 px-2 mt-2">
                FACTURAR A
            </div>
            @if (invoiceToCompany) {
                <div class="text-zinc-500 text-md">
                <p>
                    
                    {{invoiceToCompany.name}}
                </p>
                <p>
                    {{invoiceToCompany.address}}
                </p>
              <div class="flex items-center">
                    <span>{{invoiceToCompany.city}} {{invoiceToCompany.state}} C.P.</span> &nbsp;
                    <div class="relative">
                        <input type="tel" mask="99999"
                            class="w-[80px] h-8 text-sm appearance-none border-2 border-gray rounded-sm pl-2 pr-5"
                            [(ngModel)]="zipCode">
                        @if(zipCode!=invoiceToCompany.zipCode){
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="absolute top-1/2 right-1 grid h-4 w-4 -translate-y-2/4 place-items-center   text-gray cursor-pointer" (click)="showModalCPAction()"><path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/><path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7"/><path d="M7 3v4a1 1 0 0 0 1 1h7"/></svg>
                        }

                    </div>
                </div>
                <p>
                    {{invoiceToCompany.phone}}
                </p>
                <p>
                    {{invoiceToCompany.email}}
                </p>
            </div>
            }@else{
                <span class="text-sm"> Buscando consumos</span>
            }
         

        </div>
        <div class="text-center w-1/2">
            <h1 class="text-lg font-semibold text-vivid-royal-500">
                FACTURA
                {{consumptions[0].tax}} %
            </h1>
            <div class=" flex w-full bg-vivid-royal-500 text-dark-khaki-50">
                <div class="w-1/2 text-center">
                    FACTURA #
                </div>
                <div class="w-1/2">
                    FECHA
                </div>

            </div>
            <div class=" flex w-full text-zinc-500 py-2">
                <div class="w-1/2 text-center">
                    ######
                </div>
                <div class="w-1/2">
                    {{dateInvoice!|date:'dd/MM/yyyy'}}
                </div>

            </div>
            <div class=" flex w-full bg-vivid-royal-500 text-dark-khaki-50  text-center">
                <div class="text-center w-full">
                    IDENTIFICACIÓN DE CLIENTE
                </div>


            </div>
            <div class=" flex w-full text-zinc-500 py-2 text-center">
                <div class=" text-center w-full">
                    {{invoiceToCompany.number.toString().padStart(5,'0')}}
                </div>
            </div>
            <div class="justify-end text-right flex w-full">
                <span class="flex text-right p-4 text-gray opacity-70  uppercase text-lg ">SIN VALIDEZ FISCAL</span>
            </div>

        </div>
    </div>

    <div class="mt-3">
        <table class="w-full mx-auto px-4 ">
            <tr class="font-bold border-b-2 p-2 border-black text-sm">
                <th>Vehículo</th>
                <th>Kms</th>
                <th>Fecha</th>
                <th>Estación</th>
                <th>Bomba</th>
                <th>Producto</th>
                <th>Precio</th>
                <th>Litros</th>
                <th>SubTotal</th>
                <th>IVA%</th>
                <th>$IVA</th>
                <th>Total</th>

            </tr>
            @for (item of consumptions; track $index) {
            <tr class="font-thin text-xs py-3 px-2 ml-2">
                <td>{{item.vehicle}}</td>
                <td>{{item.kms}}</td>
                <td>{{item.date | date:'dd/MM/yyyy'}}</td>
                <td>{{item.station}}</td>
                <td>{{item.pump}}</td>
                <td>{{item.product}}</td>
                <td>{{item.price|currency}}</td>
                <td>{{item.liter|number}} Lts</td>
                <td>{{item.subtotal|currency}}</td>
                <td>{{item.tax}}%</td>
                <td>{{item.taxAmount| currency}}</td>
                <td>{{item.amount |currency}} </td>
            </tr>
            }
        </table>
    </div>
   
    }@else{
    <div class="mt-3">
        <table class="w-full mx-auto px-4 ">
            <tr class="font-bold border-b-2 p-2 border-black text-sm">
                <th>Nombre</th>
                <th>RFC</th>
                <th>total</th>
                <th></th>


            </tr>
            @for (item of consumptions; track $index) {
            <tr class="font-thin text-xs py-3">
                <td>{{item.clientName}}</td>
                <td>{{item.clientrfc}}</td>
                <td>{{item.total | currency}}</td>
                <td>
                    <div class="flex space-x-3">
                        <button class="text-sm text-gray" (click)="downloadFile(item,'PDF')">Factura</button>
                        <button class="text-sm text-gray" (click)="downloadFile(item,'XML')">XML</button>
                    </div>
                </td>

            </tr>
            }
        </table>
    </div>
    }

</div>